import { render } from "./SponsorFAQ.vue?vue&type=template&id=7c06247e&scoped=true"
import script from "./SponsorFAQ.vue?vue&type=script&lang=js"
export * from "./SponsorFAQ.vue?vue&type=script&lang=js"

import "./SponsorFAQ.vue?vue&type=style&index=0&id=7c06247e&scoped=true&lang=scss"

import exportComponent from "/builds/threatinformant/conference/exploit-marketing-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c06247e"]])

export default __exports__